/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiScenarioLanguage {
    SQL = 'SQL',
    JMESPATH = 'JMESPATH'
}


export function instanceOfInternalApiScenarioLanguage(value: any): boolean {
    for (const key in InternalApiScenarioLanguage) {
        if (Object.prototype.hasOwnProperty.call(InternalApiScenarioLanguage, key)) {
            if (InternalApiScenarioLanguage[key as keyof typeof InternalApiScenarioLanguage] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiScenarioLanguageFromJSON(json: any): InternalApiScenarioLanguage {
    return InternalApiScenarioLanguageFromJSONTyped(json, false);
}

export function InternalApiScenarioLanguageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioLanguage {
    return json as InternalApiScenarioLanguage;
}

export function InternalApiScenarioLanguageToJSON(value?: InternalApiScenarioLanguage | null): any {
    return value as any;
}

export function InternalApiScenarioLanguageToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiScenarioLanguage {
    return value as InternalApiScenarioLanguage;
}

